module.exports = __webpack_public_path__ + "static/media/Logo.3fbf5a84.svg";